var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isManager('project|management|finance') && _vm.rowData.count == 0 || _vm.isSuper())?_c('el-button',{attrs:{"icon":"fa fa-trash-alt","size":"small","type":"danger","circle":""},on:{"click":function($event){return _vm.deleteEntry()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }